import { Skeleton } from './index'
import { HTMLAttributes } from 'react'

function SkeletonDefault({ ...props }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div className="flex items-center space-x-4" {...props}>
      <Skeleton className="h-12 w-12 rounded-full" />
      <div className="space-y-2 w-full">
        <Skeleton className="h-4 w-full" />
        <Skeleton className="h-4 w-full" />
      </div>
    </div>
  )
}
export { SkeletonDefault }
